<template>
  <div class="main-container">
    <div class="main-form">

      <h2 class="main-title">Create New Partner</h2>

      <div class="form">
        <div class="form__row">
          <div class="form__input-box">
            <label class="form__label">Partner name (required)</label>
            <input
              type="text"
              :class="{'form__input': true, 'is-error': errors.has('name')}"
              v-model="partnerName"
              v-validate="'required'"
              name="name"
              v-input-trim
            >

            <span class="form__error" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
        </div>

        <div class="form__row" v-if="createPartnerError">
          <span class="creation-edition-error">{{createPartnerError}}</span>
        </div>

        <div class="form__row">
          <div class="btns-row__right-btns">
            <button v-if="$checkRoles(['Administrator'])"
                    class="ark-btn ark-btn--default"
                    @click="createPartner">
              <span>Create</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <InfoModal
      v-if="partnerIsCreated"
      :msg="'Partner was successfully created.'"
      :onCloseModal="closeInfoModal"
    ></InfoModal>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import InfoModal from '../../InfoModal/InfoModal.vue'

  export default {
    components: {Loader, InfoModal},
    name: 'CreateForm',
    props: ['getPartner', 'partners'],
    data () {
      return {
        partnerName: '',
        createPartnerError: '',
        isLoadingBtn: false,
        partnerIsCreated: false
      }
    },
    methods: {
      createPartner: function () {
        this.$validator.validateAll().then((isValid) => {
          if (isValid) {
            this.isLoadingBtn = true

            const formData = new FormData()
            const textData = JSON.stringify({
              'Name': this.partnerName
            })

            formData.append('JsonData', textData)

            this.$http.post(`${config.apiUrl}/partners/create`, formData)
              .then(response => {
                // this.createdDomain = response.body.url
                this.partnerIsCreated = true

                // resetting form after creation success
                this.partnerName = ''
                this.createPartnerError = ''
                this.$validator.reset()
              }, error => {
                console.log(error, 'partner creation error')
                this.createPartnerError = error.body.Message
                this.isLoadingBtn = false
              })
          }
        })
      },
      closeInfoModal: function () {
        this.partnerIsCreated = false
        this.$emit('partner-created')
      }
    }
  }
</script>

<style scoped src="./CreateForm.scss" lang="scss"></style>
